<template>
  <div class="kpi-finance-page" v-if="true">
    <div class="head">
      <div class="top">
        <div class="money">
          <div class="title">可提现金额(元)</div>
          <div class="btn">
            <span class="num">{{info.availableMoney}}</span>
            <van-button round @click="withdraw">提现</van-button>
          </div>
        </div>
      </div>
      <div class="reward-group">
        <div>
          <div class="number">{{info.totalMoney}}</div>
          <div class="word">奖励总金额</div>
        </div>
        <div>
          <div class="number">{{info.withdrawnMoney}}</div>
          <div class="word">已提取金额</div>
        </div>
        <div>
          <div class="number">{{info.autoMoney}}</div>
          <div class="word">自动到账金额</div>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="tip bottom-line">收支明细</div>
      <van-list v-model="params.loading" :finished="params.finished" finished-text="— 暂无更多数据 —">
        <van-cell v-for="(item,index) of info.bonusDetailList" :key="index">
          <div class="flex">
            <div class="one-nowrap">{{item.name}}</div>
            <div v-if="true" class="active">+{{item.amount}}</div>
            <!-- <div v-if="Number(score) <= 0">1111</div> -->
          </div>
          <div class="time">
            <div>{{item.createTime}}</div>
            <span v-if="item.clearingType=='auto'" style="color:#909399;" class="mr10">自动到账</span>
            <span v-if="item.remark=='second'" style="color:red;">超出每秒预设的阈值</span>
            <span v-if="item.remark=='hour'" style="color:red;">超出每小时预设的阈值</span>
            <span v-if="item.remark=='day'" style="color:red;">超出每天预设的阈值</span>
            <span v-if="item.remark=='qcloud'" style="color:red;">腾讯云判断异常</span>
          </div>
        </van-cell>
      </van-list>
    </div>

    <back-home
      :activity_id="activity_id"
      :user_id="user_id"
      :kpi_uid="kpi_userid"
      :share_uid="share_userid"
    ></back-home>

    <!-- <app-footer></app-footer> -->
  </div>
</template>

<script>
import backHome from "../../components/back-home.vue";
// import appFooter from '../../components/kpi-footer';

export default {
  components: {
    backHome,
    // appFooter
  },
  data() {
    return {
      activity_id: localStorage.getItem("act_id"),
      user_id: localStorage.getItem("user_id"),
      kpi_userid: localStorage.getItem("kpi_user_id") || null,
      share_userid: localStorage.getItem("share_user_id") || null,
      info: {},
      params: {
        loading: false,
        finished: true,
        page: 1,
      },
    };
  },
  created() {
    this.getInfo();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    getInfo() {
      this.params.loading = true;
      this.$kpi.finance.getFinanceInfo().then((res) => {
        this.params.loading = false;
        console.log(res);
        this.info = res || {};
        this.params.finished = true;
      });
    },
    // 提现
    withdraw() {
      this.$router.push({
        name: "kpi.withdraw",
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.kpi-finance-page {
  padding-bottom: 50px;
  .head {
    .top {
      background: url("https://j.weizan.cn/youxiang/images/finance_img.jpg")
        no-repeat 0 0;
      background-size: 100% 100%;
      img {
        width: 100%;
        vertical-align: bottom;
      }
      .money {
        color: #ffffff;
        padding: 30px 20px;
        .title {
          color: rgba(255, 255, 255, 0.7);
          margin-bottom: 5px;
        }
        .btn {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .num {
            font-size: 24px;
          }
          .van-button {
            height: 26px;
            line-height: 24px;
            font-size: 14px;
            padding: 0px 20px;
            color: #ffffff;
            background-color: #1163eb;
          }
        }
      }
    }
    .reward-group {
      /*金额*/
      font-size: 12px;
      background-color: #ffffff;
      padding: 15px 0px;
      text-align: center;
      display: flex;
      flex: 1;
      justify-content: space-around;
      align-items: center;
      & > div {
        flex: 1;
        border-right: 1px solid #f4f4f4;
      }
      & > div:last-child {
        border: none;
      }
      .number {
        color: #3283fa;
        font-size: 17px;
      }
      .word {
        color: #999999;
        padding-top: 10px;
      }
    }
    .van-button--small {
      height: 26px;
      min-width: 48px;
      font-size: 12px;
      line-height: 24px;
    }
    .van-field__button {
      padding: 0px !important;
    }
  }
  .van-cell:not(:last-child)::after {
    left: 0px;
  }
  .content {
    background-color: #ffffff;
    margin-top: 10px;
    .tip {
      padding: 10px 15px;
    }
    .flex {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: space-between;
    }
    .active {
      color: #3283fa;
    }
    .time {
      color: #999999;
      font-size: 12px;
    }
  }
}
</style>
